// pages/HomePage.jsx
import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import Navbar from '../components/Navbar';
import HeroCarousel from '../components/HeroCarousel';
import FeaturedExperience from '../components/FeaturedExperience';
import PromotionsSection from '../components/PromotionsSection';
import MembershipSpotlight from '../components/MembershipSpotlight';
import DiningOptions from '../components/DiningOptions';
import NewsletterSignup from '../components/NewsletterSignup';
import Footer from '../components/Footer';

const HomePage = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box>
      <Navbar />
      <Box component="main">
        <HeroCarousel />
        <FeaturedExperience />
        <PromotionsSection />
        <MembershipSpotlight />
        <DiningOptions />
        <NewsletterSignup />
      </Box>
      <Footer />
    </Box>
  );
};

export default HomePage;